export const lyLessons = [
  {
    id: 'ly-1',
    title: 'Ba định luật Newton về chuyển động',
    slug: 'ba-dinh-luat-newton',
    grade: 10,
    subject: 'Vật lý',
    views: 25600,
    readTime: 22,
    excerpt: 'Tìm hiểu ba định luật Newton: định luật I (quán tính), II (F=ma), III (tác dụng - phản tác dụng).',
    category: 'Cơ học'
  },
  {
    id: 'ly-2',
    title: 'Định luật Ôm và điện trở',
    slug: 'dinh-luat-ohm',
    grade: 9,
    subject: 'Vật lý',
    views: 32100,
    readTime: 20,
    excerpt: 'Định luật Ôm: U = I.R, cách tính điện trở, công suất điện và năng lượng tiêu thụ.',
    category: 'Điện học'
  },
  {
    id: 'ly-3',
    title: 'Định luật bảo toàn năng lượng',
    slug: 'dinh-luat-bao-toan-nang-luong',
    grade: 10,
    subject: 'Vật lý',
    views: 21800,
    readTime: 18,
    excerpt: 'Định luật bảo toàn năng lượng trong cơ học: thế năng, động năng và cơ năng.',
    category: 'Cơ học'
  },
  {
    id: 'ly-4',
    title: 'Định luật khúc xạ ánh sáng',
    slug: 'dinh-luat-khuc-xa-anh-sang',
    grade: 11,
    subject: 'Vật lý',
    views: 18900,
    readTime: 16,
    excerpt: 'Định luật khúc xạ, chiết suất môi trường và hiện tượng phản xạ toàn phần.',
    category: 'Quang học'
  },
  {
    id: 'ly-5',
    title: 'Chuyển động thẳng đều',
    slug: 'chuyen-dong-thang-deu',
    grade: 8,
    subject: 'Vật lý',
    views: 27400,
    readTime: 14,
    excerpt: 'Khái niệm chuyển động thẳng đều, công thức tính vận tốc v = s/t và bài tập áp dụng.',
    category: 'Cơ học'
  },
  {
    id: 'ly-6',
    title: 'Áp suất chất lỏng - Định luật Pascal',
    slug: 'ap-suat-chat-long',
    grade: 8,
    subject: 'Vật lý',
    views: 23700,
    readTime: 17,
    excerpt: 'Công thức áp suất p = F/S, định luật Pascal và ứng dụng trong máy ép thủy lực.',
    category: 'Chất lỏng'
  }
];
